<template>
  <section class="section">
    <div class="container has-text-centered">
      <h2 v-html="$t('profile.OSRBirdStatus.introSection.title', { sppName: state?.sppName })"></h2>
      <div class="condensed bold richtext" v-html="$t('profile.OSRBirdStatus.introSection.description', { sppName: state?.sppName })"></div>
      <h4>{{ $t("profile.ABStatus.sectionIntroLead") }} </h4>
      <p>
        <template v-for="(section, index) in sections" :key="'OSRStatusSection' + index">
          <a :href="profilePageUrl + '#' + section" class="button is-primary">
            {{ $t("profile.OSRBirdStatus." + section + ".sectionShortHeader") }}
          </a>
        </template>
      </p>
    </div>
  </section>
</template>
<script>
import { osrTabSections as sections } from '@/config/profile-config';
import { useApp } from '@/composables/state/profileState';

export default {
  name: 'osr-status-intro',
  setup (props) {
    const { profilePageUrl, state } = useApp();
    return {
      state,
      profilePageUrl,
      sections
    }
  }
}
</script>

<style scoped>
@import "../ABStatus/status-intro.css";
</style>
